"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _ui = require("@unite-us/ui");
var _serviceTypes = _interopRequireDefault(require("../../utils/serviceTypes"));
var _addresses = _interopRequireDefault(require("../../utils/addresses"));
var _constants = _interopRequireDefault(require("../../utils/constants"));
var _arrays = _interopRequireDefault(require("../../utils/arrays"));
var _phones = _interopRequireDefault(require("../../utils/phones"));
var _urls = _interopRequireDefault(require("../../utils/urls"));
var _constants2 = require("../../hours/HoursOfOperation/constants");
var _utils = require("../../hours/HoursOfOperation/utils");
var _EmailAddress = _interopRequireDefault(require("../../contact/EmailAddress"));
var _ProviderCardAddRemoveButton = _interopRequireDefault(require("./components/ProviderCardAddRemoveButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ProviderCard = /*#__PURE__*/function (_Component) {
  _inherits(ProviderCard, _Component);
  var _super = _createSuper(ProviderCard);
  function ProviderCard(props) {
    var _this;
    _classCallCheck(this, ProviderCard);
    _this = _super.call(this, props);
    _this.onAddProvider = _this.onAddProvider.bind(_assertThisInitialized(_this));
    _this.onRemoveProvider = _this.onRemoveProvider.bind(_assertThisInitialized(_this));
    _this.onDetailClick = _this.onDetailClick.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ProviderCard, [{
    key: "onAddProvider",
    value: function onAddProvider(destinationLatLng) {
      var _this$props = this.props,
        provider = _this$props.provider,
        onAddProvider = _this$props.onAddProvider,
        originLatLng = _this$props.originLatLng;
      var distance = _addresses["default"].getDistanceInMiles(originLatLng, destinationLatLng, {
        format: 'float'
      });
      var providerWithDistance = _objectSpread(_objectSpread({}, provider), {}, {
        distance: distance
      });
      onAddProvider(providerWithDistance);
    }
  }, {
    key: "onRemoveProvider",
    value: function onRemoveProvider() {
      var _this$props2 = this.props,
        provider = _this$props2.provider,
        onRemoveProvider = _this$props2.onRemoveProvider;
      onRemoveProvider(provider);
    }
  }, {
    key: "onDetailClick",
    value: function onDetailClick() {
      var _this$props3 = this.props,
        provider = _this$props3.provider,
        onDetailClick = _this$props3.onDetailClick;
      onDetailClick(provider);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        className = _this$props4.className,
        disableSelection = _this$props4.disableSelection,
        isSelected = _this$props4.isSelected,
        onDetailClick = _this$props4.onDetailClick,
        originLatLng = _this$props4.originLatLng,
        provider = _this$props4.provider,
        selectedServiceType = _this$props4.selectedServiceType,
        unselectable = _this$props4.unselectable;
      var date = new Date();
      var today = _constants2.DAYS_OF_THE_WEEK[date.getDay() - 1];
      var hasHoursOfOperation = !(0, _lodash.isEmpty)(provider.hours_of_operation) || !(0, _lodash.isEmpty)(provider.hours);
      var hoursDisplay = '';
      var todayHours = [];
      if (provider.hours_of_operation !== undefined) {
        todayHours = (0, _lodash.find)(provider.hours_of_operation, {
          day_of_week: today
        }) || {};
        hoursDisplay = (0, _lodash.map)((0, _lodash.orderBy)(todayHours.hours_of_operation, 'opens_at'), _utils.formatDuration).join(', ');
      } else {
        todayHours = (0, _lodash.get)(provider, ['hours', today], []);
        hoursDisplay = (0, _lodash.map)(todayHours, _utils.formatDuration).join(', ');
      }
      var email = _arrays["default"].findPrimaryOrFirst(provider.email_addresses);
      var phone = _arrays["default"].findPrimaryOrFirst(provider.phone_numbers);
      var destinationLatLng = provider.addresses[0] && provider.addresses[0].lat_lng !== undefined ? (0, _lodash.get)(provider, 'addresses[0].lat_lng', []) : [(0, _lodash.get)(provider, 'addresses[0].latitude', []), (0, _lodash.get)(provider, 'addresses[0].longitude', [])];
      var distance = _addresses["default"].getDistanceInMiles(originLatLng, destinationLatLng);
      var detailsProps = !onDetailClick ? {} : {
        onClick: this.onDetailClick,
        onKeyPress: this.onDetailClick,
        role: 'button',
        style: {
          cursor: 'pointer'
        },
        tabIndex: 0
      };
      var isInNetworkGroup = (0, _lodash.get)(provider, 'group_type') === _constants["default"].IN_NETWORK_GROUP_TYPE || (0, _lodash.get)(provider, 'licensed') === true;
      var providerServiceTypes = provider.service_types;
      var serviceTypes = _serviceTypes["default"].matchingServiceTypes(selectedServiceType, providerServiceTypes);
      var svcTypeBanner = _serviceTypes["default"].serviceTypeBanner(serviceTypes);
      var addressString = _addresses["default"].getAddressString((0, _lodash.get)(provider, 'addresses[0]'));
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('ui-provider-card', className)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('ui-provider-card__info', {
          'ui-provider-card__info-disabled': disableSelection
        })
      }, /*#__PURE__*/_react["default"].createElement("div", _extends({
        className: "ui-provider-card__detail"
      }, detailsProps), !isInNetworkGroup && /*#__PURE__*/_react["default"].createElement("div", {
        className: "ui-provider-card__oon"
      }, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
        icon: "IconElectronsArrow",
        size: 20,
        className: "mr-half"
      }), /*#__PURE__*/_react["default"].createElement("span", null, "Out of Network Organization")), /*#__PURE__*/_react["default"].createElement("h4", {
        className: "ui-provider-card__name"
      }, provider.name), !(0, _lodash.isEmpty)(svcTypeBanner) && /*#__PURE__*/_react["default"].createElement("p", {
        className: "ui-provider-card__service-type"
      }, svcTypeBanner), !(0, _lodash.isEmpty)(provider.addresses) && /*#__PURE__*/_react["default"].createElement("p", {
        className: "ui-provider-card__address mb-quarter",
        title: addressString
      }, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
        icon: "IconMapMarker",
        size: 16
      }), addressString), !(0, _lodash.isEmpty)(distance) && /*#__PURE__*/_react["default"].createElement("p", {
        className: "ui-provider-card__distance mb-quarter"
      }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
        icon: "IconCompass",
        size: 16
      })), /*#__PURE__*/_react["default"].createElement("span", null, distance)), hasHoursOfOperation && /*#__PURE__*/_react["default"].createElement("p", {
        className: "ui-provider-card__hours mb-quarter"
      }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
        icon: "IconClock",
        size: 16
      })), /*#__PURE__*/_react["default"].createElement("span", null, "TODAY:\xA0"), /*#__PURE__*/_react["default"].createElement("span", null, (0, _lodash.isEmpty)(todayHours) ? _constants2.CLOSED_DAY : hoursDisplay)), !(0, _lodash.isEmpty)(phone) && /*#__PURE__*/_react["default"].createElement("p", {
        className: "ui-provider-card__phone mb-quarter"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: _phones["default"].getTelLink(phone),
        target: "_blank",
        tabIndex: 0,
        rel: "noopener noreferrer"
      }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
        icon: "IconPhone",
        size: 12
      })), _phones["default"].formatPhoneNumber(phone.extension ? phone.phone_number + phone.extension : phone.phone_number))), /** @todo Do we need a way to hide emails in emr? */
      !(0, _lodash.isEmpty)(email) && /*#__PURE__*/_react["default"].createElement("p", {
        className: "ui-provider-card__email mb-quarter"
      }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
        icon: "IconEnvelope",
        size: 16
      }), /*#__PURE__*/_react["default"].createElement(_EmailAddress["default"], {
        emailAddress: email.email_address
      }))), provider.website_url && /*#__PURE__*/_react["default"].createElement("p", {
        className: "ui-provider-card__url mb-quarter"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: _urls["default"].addHttpIfNeeded(provider.website_url),
        target: "_blank",
        rel: "noopener noreferrer",
        tabIndex: 0
      }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
        icon: "IconWeb",
        size: 16
      })), provider.website_url)))), !disableSelection && !unselectable && /*#__PURE__*/_react["default"].createElement(_ProviderCardAddRemoveButton["default"], {
        selected: isSelected,
        distance: distance,
        destinationLatLng: destinationLatLng,
        onAddClick: this.onAddProvider,
        onRemoveClick: this.onRemoveProvider
      }));
    }
  }]);
  return ProviderCard;
}(_react.Component);
ProviderCard.propTypes = {
  /** className */
  className: _propTypes["default"].string,
  /** true for disabled card state, hidden add/remove button */
  disableSelection: _propTypes["default"].bool,
  /** true indicates this provider is selected */
  isSelected: _propTypes["default"].bool,
  /** called on add button click */
  onAddProvider: _propTypes["default"].func,
  /** called on provider card click */
  onDetailClick: _propTypes["default"].func,
  /** called on remove button click */
  onRemoveProvider: _propTypes["default"].func,
  /** center of map to calculate distance */
  originLatLng: _propTypes["default"].array,
  /** object containing provider data */
  provider: _propTypes["default"].shape({
    addresses: _propTypes["default"].array,
    email_addresses: _propTypes["default"].array,
    group_type: _propTypes["default"].string,
    hours: _propTypes["default"].object,
    hours_of_operation: _propTypes["default"].array,
    name: _propTypes["default"].string,
    phone_numbers: _propTypes["default"].array,
    programs: _propTypes["default"].array,
    service_types: _propTypes["default"].array,
    website_url: _propTypes["default"].string
  }).isRequired,
  /** service type object or array of service type objects */
  selectedServiceType: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    name: _propTypes["default"].string
  })), _propTypes["default"].shape({
    id: _propTypes["default"].string,
    name: _propTypes["default"].string
  })]).isRequired,
  /** true to hide add/remove buttons */
  unselectable: _propTypes["default"].bool
};
ProviderCard.defaultProps = {
  className: '',
  disableSelection: false,
  isSelected: false,
  onAddProvider: _lodash.noop,
  onDetailClick: _lodash.noop,
  onRemoveProvider: _lodash.noop,
  originLatLng: [],
  unselectable: false
};
var _default = exports["default"] = ProviderCard;